// this file is @generated

// biome-ignore-all lint/suspicious/noEmptyInterface: backwards compat

export interface HubspotConfigOut {}

export const HubspotConfigOutSerializer = {
  _fromJsonObject(_object: any): HubspotConfigOut {
    return {};
  },

  _toJsonObject(_self: HubspotConfigOut): any {
    return {};
  },
};
